import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { PhotoService } from "../../shared/photo.service";

@Component({
    selector: 'app-photo-detail',
    templateUrl: './photo-detail.component.html',
    styleUrls: ['./photo-detail.component.scss']
})
export class PhotoDetailComponent implements OnInit {
    photo = null;
    id = null;

    constructor(private photoService: PhotoService, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe((params) => {
            let id = params['id'];
            if (id)
                this.loadPhoto(id);
        })
    }

    ngOnInit() {
    }

    loadPhoto(id) {
        this.photoService.getPhoto(id)
            .then(data => {
                this.photo = data;
                this.id = parseInt(id);
            })
            .catch(errors => {
                console.log('errors: ', errors);
            })
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/photo-detail/photo-detail.component.ts